<div>
    <app-notification class="sticky-notification" title="Enregistrement impossible" color="#e37055" *ngIf="errorMessages.length && !isValidForm">
        <ul>
          <li *ngFor="let error of errorMessages">{{error}}</li>
        </ul>
    </app-notification>
    <div class="content-add-title-wrapper">
        <h2 class="admin-page-title">{{ isEdition ? 'Modifier' : 'Ajouter une nouvelle' }} {{ isEdition ? 'la' : ''}} ressource</h2>
        <app-icon
            *ngIf="isEdition"
            class="content-add-delete-icon"
            (click)="deleteContent()"
            type="trash"
            size="30"
            button></app-icon>
    </div>
    
    <form class="margin-top" [formGroup]="contentForm">
        <div class="row gap">
            <div class="create-content-title-wrapper">
                <app-input title="Titre" formControlName="title"></app-input>
            </div>
        </div>
        <div>
            <p>Description</p>
            <div class="NgxEditor__Wrapper margin-top">
                <ngx-editor-menu [toolbar]="toolbar" [editor]="editor"></ngx-editor-menu>
                <ngx-editor
                    [editor]="editor"
                    formControlName="description"
                    [placeholder]="'Décrivez la ressource...'">
                </ngx-editor>
            </div>
        </div>
        <div class="column gap create-content-format-section">
            <!-- Note: Objectif field removed per REMOVE-OBJECTIF.txt requirements -->
            <div class="row">
                <app-radio-buttons class="create-content-format-item" formControlName="format" title="Format" [options]="formatsNames"></app-radio-buttons>
                <div class="duration-container">
                    <div>Durée</div>
                    <input class="time-input" type="time" step="1" formControlName="readingDuration" value="00:00:00">
                </div>
            </div>
            <ng-container  *ngIf="contentForm?.get('format')?.value">
                <div>Média associé</div>
                <p class="media-help-text" *ngIf="!content">
                    Sélectionnez un fichier - l'upload se fera automatiquement lors de l'enregistrement
                </p>
                <div class="existing-media-indicator" *ngIf="content?.resource && !fileModified">
                    <div class="existing-media-badge">
                        <app-icon type="check" size="16"></app-icon>
                        <span>Fichier existant</span>
                    </div>
                    <div class="existing-media-info">
                        <small>{{ content.resource }}</small>
                    </div>
                </div>
                <div class="create-content-media-container">
                    <div class="create-content-media-flex-item">
                        <app-upload-large-file
                            #uploadLargeFileComponent
                            [mimeTypes$]="acceptingMimeTypes$"
                            (updateFile)="updateFile($event)"
                            (uploadComplete)="onUploadComplete($event)"
                            (uploadError)="onUploadError($event)"
                            (uploadProgress$)="onUploadProgress($event)"
                            [update]="!!content"
                            showMessage="false"
                            showFileName="true"
                            [image]="isImageFormat()"
                            [video]="isVideoFormat()"
                            [audio]="isAudioFormat()"
                            [pdf]="isPdfFormat()"
                            entityName="contents"
                            [entityId]="content?.id || ''"
                            [isCover]="false">
                        </app-upload-large-file>
                    </div>
                    <div class="create-content-media-flex-item or-wrapper">ou</div>
                    <app-input class="create-content-media-flex-item" title="Url" formControlName="resource"></app-input>
                </div>
            </ng-container>
        </div>
        <div
            class="captions-panel"
            *ngIf="isVideoFormat()"
            @captionsPanel>
            <div class="captions-panel__header">
                <p class="captions-panel__title">Sous-titres (VTT)</p>
                <p class="captions-panel__hint">
                    Ajoutez un fichier WebVTT par langue. En création, les fichiers seront envoyés à l'enregistrement.
                </p>
            </div>

            <div class="captions-panel__uploader">
                <label class="captions-panel__lang">
                    <span>Langue</span>
                    <select
                        class="captions-panel__select"
                        [(ngModel)]="selectedCaptionLang"
                        [ngModelOptions]="{standalone: true}"
                        [disabled]="captionBusy">
                        <option *ngFor="let code of captionLangCodes" [value]="code">
                            {{ getLangLabel(code) }}
                        </option>
                    </select>
                </label>

                <button
                    type="button"
                    class="captions-panel__upload-btn"
                    (click)="captionFileInput.click()"
                    [disabled]="captionBusy || !!captionJobInProgress">
                    Ajouter un fichier .vtt
                </button>
                <button
                    type="button"
                    class="captions-panel__upload-btn captions-panel__upload-btn--secondary"
                    *ngIf="content?.id"
                    (click)="startWhisperGeneration()"
                    [disabled]="!canStartWhisperGeneration()"
                    [attr.title]="whisperAudioHint() || null">
                    Générer (Whisper FR → EN)
                </button>
                <input
                    #captionFileInput
                    class="captions-panel__file-input"
                    type="file"
                    accept=".vtt,text/vtt"
                    (change)="onCaptionFileSelected($event)"
                    [disabled]="captionBusy">
            </div>

            <div class="captions-panel__job" *ngIf="captionJob">
                <div class="captions-panel__job-bar">
                    <span class="captions-panel__job-fill" [style.width.%]="captionJob.progress || 0"></span>
                </div>
                <p class="captions-panel__job-text">
                    {{ captionJob.progressMessage || captionJob.status }}
                    <ng-container *ngIf="captionJob.progress != null"> — {{ captionJob.progress }}%</ng-container>
                </p>
                <p class="captions-track__error" *ngIf="captionJob.errorMessage">{{ captionJob.errorMessage }}</p>
            </div>

            <p class="captions-panel__youtube-hint" *ngIf="whisperAudioHint() as hint">
                {{ hint }}
            </p>

            <ul
                class="captions-panel__list"
                *ngIf="captions.length || pendingCaptionFiles.length"
                [@captionList]="captions.length + pendingCaptionFiles.length">
                <li class="captions-track" *ngFor="let caption of captions">
                    <div class="captions-track__main">
                        <div class="captions-track__meta">
                            <span class="captions-track__lang">{{ caption.label }} ({{ caption.lang }})</span>
                            <span class="captions-track__badge">{{ caption.status || 'published' }}</span>
                            <span
                                class="captions-track__badge"
                                [ngClass]="youtubeSyncBadgeClass(caption.youtubeSyncStatus)"
                                *ngIf="caption.youtubeSyncStatus && caption.youtubeSyncStatus !== 'none'">
                                YT: {{ caption.youtubeSyncStatus }}
                            </span>
                        </div>
                        <div class="captions-track__actions">
                            <button
                                type="button"
                                class="captions-track__action captions-track__action--ghost"
                                *ngIf="caption.cues?.length"
                                (click)="openCueEditor(caption)"
                                [disabled]="captionBusy">
                                Éditer
                            </button>
                            <button
                                type="button"
                                class="captions-track__action captions-track__action--primary"
                                *ngIf="caption.lang !== 'fr' && caption.cues?.length"
                                (click)="startDub(caption.lang)"
                                [disabled]="captionBusy || caption.dubStatus === 'processing'">
                                {{ caption.dubStatus === 'processing' ? ('Voix en cours… ' + formatDubElapsed(caption.lang)) : (caption.dubAudioUrl ? 'Regénérer la voix' : 'Générer la voix') }}
                            </button>
                            <button
                                type="button"
                                class="captions-track__action captions-track__action--primary"
                                *ngIf="caption.status !== 'published'"
                                (click)="publishCaption(caption.lang)"
                                [disabled]="captionBusy">
                                Publier
                            </button>
                            <button
                                type="button"
                                class="captions-track__action captions-track__action--primary"
                                *ngIf="isYoutubeResource()"
                                (click)="publishCaptionToYoutube(caption.lang)"
                                [disabled]="captionBusy">
                                Publier sur YouTube
                            </button>
                            <button
                                type="button"
                                class="captions-track__action captions-track__action--danger"
                                (click)="deleteCaption(caption.lang)"
                                [disabled]="captionBusy">
                                Supprimer
                            </button>
                        </div>
                    </div>
                    <div class="captions-track__dub-progress" *ngIf="caption.dubStatus === 'processing'">
                        <div class="captions-track__dub-bar" aria-hidden="true">
                            <span class="captions-track__dub-fill"></span>
                        </div>
                        <p class="captions-track__dub-text">
                            Génération de la voix en cours{{ formatDubElapsed(caption.lang) }} —
                            cela peut prendre quelques minutes selon la durée de la piste.
                        </p>
                    </div>
                    <p class="captions-track__error" *ngIf="caption.youtubeSyncError">
                        {{ caption.youtubeSyncError }}
                    </p>
                    <p class="captions-track__error" *ngIf="caption.dubStatus === 'failed' && caption.dubError">
                        {{ caption.dubError }}
                    </p>
                    <audio
                        *ngIf="caption.dubAudioUrl"
                        class="captions-track__audio"
                        controls
                        [src]="caption.dubAudioUrl">
                    </audio>
                </li>
                <li class="captions-track captions-track--pending" *ngFor="let pending of pendingCaptionFiles">
                    <div class="captions-track__main">
                        <div class="captions-track__meta">
                            <span class="captions-track__lang">{{ getLangLabel(pending.lang) }} ({{ pending.lang }})</span>
                            <span class="captions-track__badge captions-track__badge--waiting">en attente</span>
                        </div>
                        <div class="captions-track__actions">
                            <button
                                type="button"
                                class="captions-track__action captions-track__action--ghost"
                                (click)="deleteCaption(pending.lang)">
                                Retirer
                            </button>
                        </div>
                    </div>
                </li>
            </ul>

            <p class="captions-panel__empty" *ngIf="!captions.length && !pendingCaptionFiles.length">
                Aucun sous-titre pour l'instant.
            </p>

            <div class="captions-editor" *ngIf="editingCaptionLang && editingCues">
                <div class="captions-editor__header">
                    <p class="captions-editor__title">Éditeur — {{ getLangLabel(editingCaptionLang) }}</p>
                    <div class="captions-track__actions">
                        <button
                            type="button"
                            class="captions-track__action captions-track__action--primary"
                            (click)="saveEditingCues()"
                            [disabled]="captionBusy">
                            Enregistrer
                        </button>
                        <button
                            type="button"
                            class="captions-track__action captions-track__action--ghost"
                            (click)="closeCueEditor()"
                            [disabled]="captionBusy">
                            Fermer
                        </button>
                    </div>
                </div>
                <div class="captions-editor__row" *ngFor="let cue of editingCues; let i = index">
                    <input class="captions-editor__time" type="number" step="0.1" min="0" [(ngModel)]="cue.start" [ngModelOptions]="{standalone: true}">
                    <input class="captions-editor__time" type="number" step="0.1" min="0" [(ngModel)]="cue.end" [ngModelOptions]="{standalone: true}">
                    <input class="captions-editor__text" type="text" [(ngModel)]="cue.text" [ngModelOptions]="{standalone: true}">
                    <button
                        type="button"
                        class="captions-editor__remove"
                        (click)="removeEditingCue(i)"
                        aria-label="Supprimer la ligne"
                        title="Supprimer">
                        ×
                    </button>
                </div>
                <button type="button" class="captions-track__action captions-track__action--ghost" (click)="addEditingCue()">+ Ajouter une ligne</button>
            </div>

            <div class="captions-panel__busy" *ngIf="captionBusy">
                <span class="captions-panel__spinner" aria-hidden="true"></span>
                Traitement en cours…
            </div>
        </div>
        <div class="row gap margin-top">
            <div class="column create-content-flex-item">
                <!-- Note: Changed from checkboxes to radio buttons - only ONE pillar can be selected per REMOVE-OBJECTIF.txt -->
                <app-radio-buttons
                    formControlName="pillar"
                    title="Pilier lié"
                    [options]="pillarNames">
                </app-radio-buttons>

                <app-checkmarks title="Thématique(s) liée(s)" [checkboxes]="thematicsAssociatedCheckboxes" item-name="selectionné"
                (changeSelection)="updateThematicsAssociated($event)"></app-checkmarks>
            </div>
            <!-- Note: Catégorie field removed per REMOVE-OBJECTIF.txt requirements -->
        </div>
        <div>
            <p class="margin-bottom">Image de couverture</p>
            <app-upload-file [mimeTypes$]=" coverImageMimeTypes$" [showFileName]="!showCoverImageUrl"  [showImageUrl]="showCoverImageUrl" [imageUrl]="coverImageUrl" (updateFile)="updateCoverImage($event)" [update]="!!content" hasLimit="false" showMessage="false" image></app-upload-file>
            <div class="cover-image-container">
                <img class="cover-image" *ngIf="showCoverImageUrl" [src]="coverImageUrl" alt="Media Image">
            </div>
        </div>
    </form>
</div>
